import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../lib/AuthContext";
import { Loader2, Lock } from "lucide-react";
import { ThemeToggle } from "../components/ui/ThemeToggle";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-bm-bg flex items-center justify-center p-6">
      <div className="fixed right-5 top-5">
        <ThemeToggle testId="login-theme-toggle" />
      </div>
      <div className="w-full max-w-sm">
        <div className="mb-8">
          <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-bm-green uppercase">
            <span className="w-1.5 h-1.5 bg-bm-green animate-pulse" /> Meolaa / Restricted
          </div>
          <h1 className="font-heading font-black text-4xl tracking-tight text-white mt-2">BLACK MIRROR</h1>
          <div className="font-mono text-[11px] text-bm-dim tracking-[0.2em] uppercase mt-1">Consumer Prediction OS · Authorised personnel only</div>
        </div>

        <form onSubmit={submit} className="bm-card p-6 space-y-4" data-testid="login-form">
          <div className="flex items-center gap-2 label-mono text-bm-amber">
            <Lock className="w-3 h-3" /> AUTHENTICATE
          </div>
          <div>
            <label className="label-mono text-bm-dim">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus
              data-testid="login-email-input" autoComplete="username"
              className="w-full bg-bm-elevated border border-white/10 px-3 py-2.5 mt-1 font-mono text-sm text-white outline-none focus:border-bm-cyan" />
          </div>
          <div>
            <label className="label-mono text-bm-dim">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              data-testid="login-password-input" autoComplete="current-password"
              className="w-full bg-bm-elevated border border-white/10 px-3 py-2.5 mt-1 font-mono text-sm text-white outline-none focus:border-bm-cyan" />
          </div>
          {error && (
            <div className="text-xs font-mono text-bm-danger border border-bm-danger/30 bg-bm-danger/5 px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <button type="submit" disabled={busy} data-testid="login-submit-btn"
            className="w-full bg-bm-amber text-black font-heading font-bold py-3 hover:bg-white transition-colors flex items-center justify-center gap-2 disabled:opacity-50">
            {busy ? <><Loader2 className="w-4 h-4 animate-spin" />VERIFYING...</> : "ENTER THE TERMINAL"}
          </button>
          <div className="font-mono text-[10px] text-bm-dim text-center">
            Invite-only. Contact your administrator for access.
          </div>
        </form>
      </div>
    </div>
  );
}
